if (!customElements.get('au-keyboard-finder')) {
  customElements.define('au-keyboard-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.items = JSON.parse(this.querySelector('[data-finder-products]').textContent);
      this.templates = new Map([...this.querySelectorAll('template[data-product-id]')].map(t => [Number(t.dataset.productId), t]));
      this.limit = 12;
      this.onPop = () => { this.restore(); this.limit = 12; this.scheduleRender(); };
      window.addEventListener('popstate', this.onPop);
      this.addEventListener('click', event => {
        const tab = event.target.closest('[data-tab]');
        if (tab) this.selectTab(tab.dataset.tab);
        if (event.target.closest('[data-clear]')) {
          this.querySelectorAll('input[type=checkbox]').forEach(input => input.checked = false);
          this.limit = 12; this.updateUrl(); this.scheduleRender();
        }
        if (event.target.closest('[data-more]')) { this.limit += 12; this.scheduleRender(); }
        if (event.target.closest('[data-retry]')) this.loadRemaining();
      });
      this.addEventListener('keydown', event => {
        if (!event.target.matches('[data-tab]') || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const tabs = [...this.querySelectorAll('[data-tab]')], i = tabs.indexOf(event.target);
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (i + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        this.selectTab(tabs[next].dataset.tab); tabs[next].focus();
      });
      this.addEventListener('change', event => {
        if (event.target.matches('input[type=checkbox], [data-sort]')) { this.limit = 12; this.updateUrl(); this.scheduleRender(); }
      });
      const order = {'layout':['100%','96%','80%','75%','65%','60%','Special'],'price':['Under $50','$50~100','$100~150','$150~200','$200~250','Above $250']};
      for (const [key, labels] of Object.entries(order)) {
        const panel = this.querySelector(`[data-panel="${key}"]`);
        [...panel.querySelectorAll('[data-option]')].sort((a,b) => labels.indexOf(a.dataset.option) - labels.indexOf(b.dataset.option)).forEach(el => panel.insertBefore(el, panel.querySelector('small')));
      }
      this.restore(); this.render(); this.loadRemaining();
    }
    disconnectedCallback() { window.removeEventListener('popstate', this.onPop); this.controller?.abort(); if (this.renderFrame) cancelAnimationFrame(this.renderFrame); }
    scheduleRender() {
      if (this.renderFrame) return;
      this.renderFrame = requestAnimationFrame(() => { this.renderFrame = null; this.render(); });
    }
    selectTab(key) {
      this.querySelectorAll('[data-tab]').forEach(tab => { const active = tab.dataset.tab === key; tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1; });
      this.querySelectorAll('[data-panel]').forEach(panel => panel.hidden = panel.dataset.panel !== key);
    }
    restore() {
      const params = new URL(location.href).searchParams;
      this.querySelectorAll('input[type=checkbox]').forEach(input => input.checked = params.getAll(input.name).includes(input.value));
      const sort = this.querySelector('[data-sort]'), saved = params.get('finder_sort');
      sort.value = [...sort.options].some(o => o.value === saved) ? saved : 'featured';
    }
    updateUrl() {
      const url = new URL(location.href);
      [...url.searchParams.keys()].filter(k => k.startsWith('finder_') || k === 'page').forEach(k => url.searchParams.delete(k));
      if (url.pathname === '/collections/keyboard-finder') url.searchParams.delete('view');
      else url.searchParams.set('view','buying-guide');
      this.querySelectorAll('[data-panel] input[type=checkbox]:checked').forEach(input => url.searchParams.append(input.name,input.value));
      if (this.querySelector('[data-sort]').value !== 'featured') url.searchParams.set('finder_sort', this.querySelector('[data-sort]').value);
      history.pushState({},'',url);
    }
    features(product, dimension) {
      if (dimension === 'price') { const price = product.price / 100; return [price < 50 ? 'Under $50' : price < 100 ? '$50~100' : price < 150 ? '$100~150' : price < 200 ? '$150~200' : price < 250 ? '$200~250' : 'Above $250']; }
      return product.features[dimension] || [];
    }
    render() {
      const selected = {};
      this.querySelectorAll('[data-panel] input[type=checkbox]:checked').forEach(input => (selected[input.name.replace('finder_','')] ||= []).push(input.value));
      let products = this.items.filter(p => Object.entries(selected).every(([dimension, values]) => values.some(value => this.features(p,dimension).includes(value))));
      const sort = this.querySelector('[data-sort]').value;
      if (sort === 'price-ascending') products.sort((a,b) => a.price-b.price);
      if (sort === 'price-descending') products.sort((a,b) => b.price-a.price);
      if (sort === 'title-ascending') products.sort((a,b) => a.title.localeCompare(b.title));
      if (sort === 'created-descending') products.sort((a,b) => Number(b.created)-Number(a.created));
      this.updateCards(products.slice(0,this.limit));
      this.querySelector('[data-status]').textContent = `${products.length} keyboards`;
      this.querySelector('[data-empty]').hidden = products.length > 0;
      this.querySelector('[data-more]').hidden = products.length <= this.limit;
      this.querySelector('[data-clear]').hidden = Object.keys(selected).length === 0;
      this.querySelectorAll('[data-option]').forEach(label => { const input = label.querySelector('input'), dimension = input.name.replace('finder_',''); label.hidden = !input.checked && !this.items.some(p => this.features(p,dimension).includes(input.value)); });
      this.querySelectorAll('[data-panel]').forEach(panel => { panel.querySelector('[data-no-options]').hidden = !!panel.querySelector('[data-option]:not([hidden])'); });
    }
    updateCards(products) {
      const results = this.querySelector('[data-results]');
      const wanted = products.filter(p => this.templates.has(p.id)).map(p => String(p.id));
      const wantedSet = new Set(wanted);
      // Keep cards whose position is unchanged. Recreating a product card also
      // restarts its image slider and swatches, which makes rapid filtering lag.
      [...results.children].forEach(card => { if (!wantedSet.has(card.dataset.finderId)) card.remove(); });
      wanted.forEach((id, index) => {
        const current = results.children[index];
        if (current?.dataset.finderId === id) return;
        let card = [...results.children].find(node => node.dataset.finderId === id);
        if (!card) {
          card = this.templates.get(Number(id)).content.firstElementChild.cloneNode(true);
          card.dataset.finderId = id;
        }
        results.insertBefore(card, current || null);
      });
    }
    async loadRemaining() {
      let next = this.querySelector('[data-next-page]')?.getAttribute('href');
      if (!next) return;
      this.controller = new AbortController();
      this.querySelector('[data-error]').hidden = true;
      try {
        while (next) {
          const url = new URL(next,location.origin); url.searchParams.set('view','buying-guide'); url.searchParams.set('section_id',this.dataset.section);
          const response = await fetch(url,{signal:this.controller.signal});
          if (!response.ok) throw new Error('Finder collection request failed');
          const doc = new DOMParser().parseFromString(await response.text(),'text/html');
          const data = JSON.parse(doc.querySelector('[data-finder-products]').textContent);
          const known = new Set(this.items.map(p => p.id)); this.items.push(...data.filter(p => !known.has(p.id)));
          doc.querySelectorAll('template[data-product-id]').forEach(t => this.templates.set(Number(t.dataset.productId),t));
          next = doc.querySelector('[data-next-page]')?.getAttribute('href');
          this.scheduleRender();
        }
        this.querySelector('[data-next-page]')?.remove();
      } catch (error) { if (error.name !== 'AbortError') this.querySelector('[data-error]').hidden = false; }
    }
  });
}
